<div *ngIf="isLive; else tickTag" class="live__container dark" [ngClass]="[position, color]">
  <div class="live__container__red-dot"></div>
  <p class="live__container__text">{{ 'player.live' | translate }}</p>
</div>

<ng-template #tickTag>
  <div *ngIf="isBlocked; else textTag" class="lock-icon" [ngClass]="position"></div>
</ng-template>

<ng-template #textTag>
  <div *ngIf="text" class="tag-bg" [ngClass]="position">
    <p class="tag-text">{{ text | translate }}</p>
  </div>
</ng-template>
